import React, { Suspense } from 'react'
import styles from "../../styles/SchoolEnquiry/confirmation-modal.module.css";
import ConfirmSvg from '../../assets/confirmation.svg'

const MdOutlineClose = React.lazy(() => import('react-icons/md').then(module => ({ default: module.MdOutlineClose })));

export default function ConfirmationPage({ handleUpdateStep, onClose }) {

    const handleSelectSlot = () => {
        handleUpdateStep(2); // Move to calendar modal
    }
    
    return (
        <div className={styles.container}>
            {/* Close button positioned absolutely */}
            <div className={styles.close} onClick={onClose}>
                <Suspense fallback={<div>Loading...</div>}>
                    <MdOutlineClose color="#5F4DC7" size={24} />
                </Suspense>
            </div>
            
            <img src={ConfirmSvg} />
            <div className={styles.boldText}>Thank You for filling the form!</div>
            <div>
                <div className={styles.normalText}>An AI expert will reach out to you shortly. </div>
                <div className={styles.normalText}>In the meantime, please pick a time slot to book SchoolAi walkthrough.</div>
            </div>
            <div className={styles.button} onClick={handleSelectSlot}>
                Select time slot
            </div>
        </div>
    )
}
